import { render, staticRenderFns } from "./organisms.vue?vue&type=template&id=7d33b07d&scoped=true&"
import script from "./organisms.vue?vue&type=script&lang=js&"
export * from "./organisms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33b07d",
  null
  
)

export default component.exports